module.exports = {
  get: function (key) {
    var val = window.localStorage.getItem(key)
    if (val && val !== undefined) {
      return JSON.parse(window.localStorage.getItem(key))
    }
  },
  put: function (key, value) {
    return window.localStorage.setItem(key, JSON.stringify(value))
  },
  clear: function () {
    var clientOptions = window.localStorage.getItem('client.options')
    var clientLanguage = window.localStorage.getItem('client.language')
    window.localStorage.clear()
    window.localStorage.setItem('client.options', clientOptions)
    window.localStorage.setItem('client.language', clientLanguage)
  },
  clearWarnings: function () {
    for (let key in window.localStorage) {
      if (key.indexOf('client.warn') === 0) {
        window.localStorage.removeItem(key)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/store/local.js